import { useMemo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import useSearchFiltersQuery from '@/containers/WorkspaceGlobalSearch/hooks/useSearchFilterQuery';
import {
  CellCreatedOn,
  CellTranscriptOccurrences,
  CellOwner,
  CellTranscriptTags,
  CellTranscriptName,
  CellProject,
} from '../Cells';

export default function useTranscriptsTableColumns() {
  const isDesktop = useMediaQuery('(min-width:900px)');
  const [searchQuery] = useSearchFiltersQuery();

  return useMemo(() => [
    {
      accessor: 'name',
      id: 'name',
      Header: 'Name',
      Cell: CellTranscriptName,
      minWidth: 150,
      maxWidth: 2,
    },
    isDesktop ? {
      accessor: 'project',
      id: 'project',
      Header: 'Project',
      Cell: CellProject,
      minWidth: 100,
      maxWidth: 1,
    } : null,
    isDesktop ? {
      accessor: 'tags',
      id: 'tags',
      Header: 'Tags',
      Cell: CellTranscriptTags,
      minWidth: 175,
      maxWidth: 0,
    } : null,
    isDesktop ? {
      accessor: 'owner',
      id: 'owner',
      Header: 'Owner',
      Cell: CellOwner,
      minWidth: 100,
      maxWidth: 0,
    } : null,
    isDesktop ? {
      accessor: 'createdOn',
      id: 'createdOn',
      Header: 'Created On',
      Cell: CellCreatedOn,
      minWidth: 125,
      maxWidth: 0,
    } : undefined,
    isDesktop && searchQuery.keywords.length && {
      accessor: 'occurrences',
      id: 'occurrences',
      Header: 'Highlights',
      Cell: CellTranscriptOccurrences,
      minWidth: 90,
      maxWidth: 0,
    },
  ].filter(Boolean), [
    isDesktop,
    searchQuery.keywords,
  ]);
}

export { useTranscriptsTableColumns };